export const hobbitenangoCost = [
  {
    item: 'Entrance Fee',
    cost: 'Q100 (~$13 USD)',
    notes: 'Includes access to all viewpoints and trails'
  },
  {
    item: 'Restaurant Credit',
    cost: 'Q50 (~$6.50 USD)',
    notes: 'Included with entrance, can be used at on-site restaurant'
  },
  {
    item: 'Shuttle from Antigua',
    cost: 'Q50-100 (~$6-13 USD)',
    notes: 'Round-trip, varies by provider'
  },
  {
    item: 'Private Driver',
    cost: 'Q200-300 (~$25-40 USD)',
    notes: 'Round-trip, more flexible timing'
  },
  {
    item: 'Uber/Taxi',
    cost: 'Q80-120 (~$10-15 USD)',
    notes: 'One-way estimate'
  }
];

export const transportOptions = [
  {
    method: 'Organized Shuttle',
    cost: 'Q50-100',
    duration: '30-40 min',
    pros: 'Affordable, scheduled departures, round-trip included',
    cons: 'Fixed schedule, may wait for other passengers'
  },
  {
    method: 'Private Driver',
    cost: 'Q200-300',
    duration: '25-30 min',
    pros: 'Flexible timing, direct route, comfortable',
    cons: 'More expensive, need to arrange pickup'
  },
  {
    method: 'Uber/Taxi',
    cost: 'Q80-120 one-way',
    duration: '25-30 min',
    pros: 'On-demand, flexible',
    cons: 'May be hard to get return ride, price varies'
  },
  {
    method: 'Hiking',
    cost: 'Free',
    duration: '2-3 hours uphill',
    pros: 'Free, scenic, good workout',
    cons: 'Steep, challenging, time-consuming'
  }
];

export const hobbitenangoCerroComparison = [
  {
    feature: 'Distance from Antigua',
    hobbitenango: '6 km northwest',
    cerroDeLaCruz: '1 km north (walkable)'
  },
  {
    feature: 'Entrance Fee',
    hobbitenango: 'Q100 (~$13 USD)',
    cerroDeLaCruz: 'Free'
  },
  {
    feature: 'Time Needed',
    hobbitenango: '2-4 hours',
    cerroDeLaCruz: '30-60 minutes'
  },
  {
    feature: 'Best For',
    hobbitenango: 'Instagram photos, families, unique experience',
    cerroDeLaCruz: 'Quick sunset views, budget travelers'
  },
  {
    feature: 'Volcano Views',
    hobbitenango: 'Excellent (Agua, Fuego, Acatenango)',
    cerroDeLaCruz: 'Good (Agua, city views)'
  },
  {
    feature: 'Food Available',
    hobbitenango: 'Full restaurant with great menu',
    cerroDeLaCruz: 'Small snack vendors only'
  }
];

export const whatToDo = [
  {
    icon: 'ri-hand-heart-line',
    title: 'Giant Hand Viewpoint',
    description: 'The most iconic photo spot at Hobbitenango. This massive hand sculpture reaches out over the valley with three volcanoes in the background. Arrive early to avoid lines.'
  },
  {
    icon: 'ri-home-smile-line',
    title: 'Hobbit Houses',
    description: 'Explore the whimsical hobbit-style houses built into the hillside. These colorful structures are perfect for photos and give the park its unique character.'
  },
  {
    icon: 'ri-contrast-drop-2-line',
    title: 'Sky Swings',
    description: 'Multiple swings positioned at the edge of the mountain offer thrilling views while you swing out over the valley. Not for those afraid of heights!'
  },
  {
    icon: 'ri-restaurant-line',
    title: 'Mountain Restaurant',
    description: 'Enjoy traditional Guatemalan food and international dishes with panoramic volcano views. Your entrance fee includes Q50 credit to use here.'
  },
  {
    icon: 'ri-walk-line',
    title: 'Nature Trails',
    description: 'Wander through pine forest trails connecting different viewpoints. The paths are well-maintained and offer quieter spots away from the main attractions.'
  },
  {
    icon: 'ri-camera-line',
    title: 'Photography Spots',
    description: 'Beyond the giant hand, find dozens of creative photo opportunities including colorful doors, mountain platforms, and artistic installations throughout the park.'
  }
];

export const proTips = [
  {
    title: 'Arrive Early',
    tip: 'Get there by 9-10 AM to beat the crowds and have the giant hand viewpoint to yourself. Weekday mornings are quietest.'
  },
  {
    title: 'Check Weather First',
    tip: 'Cloud cover can completely obscure the volcano views. Check the forecast and aim for clear mornings during dry season (November-April).'
  },
  {
    title: 'Bring Layers',
    tip: 'At 2,500 meters elevation, it can be cool and windy even on sunny days. Bring a light jacket or sweater.'
  },
  {
    title: 'Use Your Restaurant Credit',
    tip: 'Your Q50 restaurant credit is included in admission. The food is actually good—try the pepián or enjoy coffee with a view.'
  },
  {
    title: 'Arrange Return Transport',
    tip: 'If taking Uber or taxi, arrange your return pickup time in advance. Cell service can be spotty, and rides aren\'t always available on-demand.'
  },
  {
    title: 'Combine with Other Activities',
    tip: 'Hobbitenango is a half-day activity. Combine it with Cerro de la Cruz in the morning or a coffee tour in the afternoon for a full day.'
  }
];

export const faqs = [
  {
    question: 'How much does Hobbitenango cost?',
    answer: 'Entrance to Hobbitenango costs Q100 (approximately $13 USD) per person. This includes access to all viewpoints, trails, and photo spots, plus Q50 credit to use at the on-site restaurant. Children under a certain age may have reduced rates.'
  },
  {
    question: 'Can you walk to Hobbitenango from Antigua?',
    answer: 'Yes, but it\'s not recommended for most visitors. The hike is about 6 km uphill and takes 2-3 hours one way on steep roads with limited sidewalks. Most people take a shuttle, taxi, or private driver (25-40 minutes).'
  },
  {
    question: 'Is Hobbitenango good for kids?',
    answer: 'Yes, Hobbitenango is family-friendly. Kids enjoy the hobbit houses, swings, and open spaces to explore. However, parents should supervise children closely near viewpoints and swings, as there are steep drop-offs.'
  },
  {
    question: 'How long do you need at Hobbitenango?',
    answer: 'Plan for 2-4 hours. This gives you time to explore all the viewpoints, take photos without rushing, enjoy a meal at the restaurant, and walk the nature trails. If you\'re just there for quick photos, 1.5-2 hours is sufficient.'
  },
  {
    question: 'Do you need reservations for Hobbitenango?',
    answer: 'Reservations are not required for general admission. You can show up and buy tickets at the entrance. However, if you\'re booking a shuttle tour from Antigua, reserve that in advance, especially on weekends.'
  },
  {
    question: 'What time does Hobbitenango open?',
    answer: 'Hobbitenango typically opens at 8:00 AM and closes around 5:00-6:00 PM. Hours may vary seasonally, so check ahead if visiting during holidays or rainy season.'
  },
  {
    question: 'Is Hobbitenango worth it?',
    answer: 'If you enjoy unique photo opportunities and volcano views, yes. It\'s especially worth it on clear days when you can see all three volcanoes. However, if you\'re on a tight budget or prefer natural, non-commercialized experiences, you might prefer free viewpoints like Cerro de la Cruz.'
  },
  {
    question: 'Can you see volcanoes from Hobbitenango?',
    answer: 'Yes! On clear days, you can see Volcán de Agua, Volcán de Fuego, and Volcán Acatenango from Hobbitenango. The views are best in the morning before clouds roll in, especially during dry season (November-April).'
  },
  {
    question: 'What should I wear to Hobbitenango?',
    answer: 'Wear comfortable walking shoes (trails can be uneven), layers for changing temperatures, and bring sunscreen and a hat. The elevation is about 2,500 meters, so it can be cooler than Antigua. Avoid flip-flops.'
  },
  {
    question: 'Is there food at Hobbitenango?',
    answer: 'Yes, there\'s a full-service restaurant with traditional Guatemalan dishes, international options, coffee, and drinks. Your entrance fee includes Q50 credit toward food and beverages. The food quality is good and the views from the restaurant are excellent.'
  }
];

export const itineraryIdeas = [
  {
    time: 'Morning Option',
    plan: 'Start at Cerro de la Cruz (free, 30 min) → Hobbitenango (2-3 hours) → Lunch at Hobbitenango restaurant → Return to Antigua by early afternoon'
  },
  {
    time: 'Afternoon Option',
    plan: 'Morning coffee tour near Antigua → Lunch in town → Hobbitenango (2-3 hours) → Return for sunset in Antigua'
  },
  {
    time: 'Full Day Adventure',
    plan: 'Early morning at Hobbitenango (8-11 AM) → Return to Antigua for lunch → Afternoon exploring Antigua markets and churches → Evening at rooftop bar'
  }
];